import { Skeleton, Stack } from '@mui/material'

export const EmploymentPaginationSkeleton = () => {
  return (
    <Stack direction="row" gap={1} ml={2} mt={2} pb={2}>
      <Skeleton height={32} variant="circular" width={32} />
      <Skeleton height={32} variant="circular" width={32} />
      <Skeleton height={32} variant="circular" width={32} />
      <Skeleton height={32} variant="circular" width={32} />
      <Skeleton height={32} variant="circular" width={32} />
    </Stack>
  )
}
